import { IsoFooterSectionProps } from "@/src/sections/iso-footer/v3";

const generateImagePaths = (
  count: number,
  color: string
): { img: string }[] => {
  return Array.from({ length: count }, (_, i) => ({
    img: `/assets/images/iso2/${color}/${i + 1}.png`,
  }));
};

export const IsoFooterSectionData_ar: IsoFooterSectionProps = {
  sectionHeading: {
    subtitle: "خدماتنا",
    title: "رفع مستوى الأعمال بالابتكار التكنولوجي",
  },
  cards: [...generateImagePaths(27, "blue")],
};
